import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import {
  DateValidationError,
  PickerChangeHandlerContext,
} from '@mui/x-date-pickers';
import { FormControl, FormLabel } from '@mui/material';
import { BLUE_GRAY_200, PRIMARY } from '../../constants/Colors';
import dayjs from 'dayjs';

interface BakeasyDatePickerProps {
  label: string;
  value?: any;
  disabled?: boolean;
  onChange?: (
    value: any,
    context: PickerChangeHandlerContext<DateValidationError>
  ) => void;
  minDate?: any;
  required?: boolean;
}
function BakeasyDatePicker(props: BakeasyDatePickerProps) {
  return (
    <FormControl fullWidth>
      <FormLabel
        sx={{ fontWeight: 'bold', fontSize: '0.95rem', marginBottom: 0.5 }}
      >
        {props.label}
        {props.required}
      </FormLabel>
      <DatePicker
        disabled={props?.disabled}
        closeOnSelect={true}
        onChange={props?.onChange}
        views={['year', 'month', 'day']}
        format={'YYYY-MM-DD'}
        value={props?.value}
        minDate={dayjs(new Date())}
        slotProps={{ textField: { size: 'small' } }}
        sx={{
          '& .MuiInputBase-input::placeholder': { fontSize: '0.9rem' },
          '& .MuiOutlinedInput-root': { borderRadius: 2 },
          '& .MuiOutlinedInput-notchedOutline': { borderColor: BLUE_GRAY_200 },
          '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: BLUE_GRAY_200,
            borderWidth: 1.5,
          },
          '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline':
            {
              borderColor: PRIMARY,
            },
        }}
      />
    </FormControl>
  );
}

export default BakeasyDatePicker;
